import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { OnboardingStatusEnum } from "@funded-here-interface/common/src/constant/enum";

export interface GetOnboardingStatusRequest {
  userId: number;
  token: string;
}

export interface GetOnboardingStatusResponse {
  status: OnboardingStatusEnum;
  name: string;
  email: string;
  userId: number;
}

const getOnboardingStatus = async ({
  userId,
  token,
}: GetOnboardingStatusRequest): Promise<GetOnboardingStatusResponse> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.TRADE_DIRECTORY)}/trade-directory/users/get-onboarding-status-user-details?user=${userId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    const data = response.data;
    if (!data) {
      throw new Error("User not found");
    }

    return {
      status: data.status as OnboardingStatusEnum,
      name: data.name,
      email: data.email,
      userId: data.userId,
    };
  } catch (error) {
    const message = getApiResponseErrorMsg(error);
    throw new Error(message);
  }
};

export default getOnboardingStatus;
